export const getReport = (type, data) => ({
  method: 'POST',
  url: `/nreports/${type}`,
  data
});

export const getContractEvents = id => ({
  method: 'GET',
  url: `/nreports/contracts/${id}`,
});

export const getAnalytics = (data) => ({
  method: 'POST',
  url: '/nreports/analytics',
  data
});